import { Skeleton, TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react'

import { useTranslation } from 'react-i18next';
function SkeletonLoadingTableData({StyledTableRow, StyledTableCell}) {

    const {t} = useTranslation();
  return (
    <>
        {Array.from({ length: 5 }).map((_, index) => (
          <StyledTableRow key={index}>
            <StyledTableCell>
              <Skeleton animation="wave" />
            </StyledTableCell>
            <StyledTableCell>
              <Skeleton animation="wave" />
            </StyledTableCell>
            <StyledTableCell>
              <Skeleton animation="wave" />
            </StyledTableCell>
            <StyledTableCell>
              <Skeleton animation="wave" />
            </StyledTableCell>
            <StyledTableCell>
              <Skeleton animation="wave" />
            </StyledTableCell>
            <StyledTableCell>
              <Skeleton animation="wave" />
            </StyledTableCell>
          </StyledTableRow>
        ))}
      </>
  )
}

export default SkeletonLoadingTableData;